import { render } from "./import.vue?vue&type=template&id=4d31d6d8&scoped=true"
import script from "./import.vue?vue&type=script&lang=js"
export * from "./import.vue?vue&type=script&lang=js"

import "./import.vue?vue&type=style&index=0&id=4d31d6d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d31d6d8"]])

export default __exports__